$(window).on('load resize scroll', function () {
  var winHeight = $(window).height();
  var calcHeight = winHeight - 205;
  $('#NavDrawer #subNav .mobile-layout').height(calcHeight);
});

$(document).ready(function () {
  var screenWidth = screen.width;
  var screenHeight = screen.height;
  var sync1 = $("#big");
  var sync2 = $("#thumbs");

  if (sync1.length > 0) {

    var slidesPerPage = 5; //globaly define number of elements per page
    var syncedSecondary = true;

    if (screenWidth < 480) {
      slidesPerPage = 3;
    }

    sync1.owlCarousel({
      items: 1,
      slideSpeed: 2000,
      nav: true,
      autoplay: false,
      autoHeight: true,
      dots: true,
      loop: true,
      responsiveRefreshRate: 200,
      navText: [
        '<svg width="11" height="19" viewBox="0 0 11 19" fill="#200E32" stroke="#200E32" xmlns="http://www.w3.org/2000/svg"> <path d="M9.7541 1.25947C10.0522 1.57398 10.0793 2.06614 9.83539 2.41294L9.7541 2.5123L3.02658 9.61082L9.7541 16.7093C10.0522 17.0239 10.0793 17.516 9.83539 17.8628L9.7541 17.9622C9.45604 18.2767 8.98963 18.3053 8.66096 18.0479L8.56679 17.9622L1.2459 10.2372C0.94784 9.92273 0.920743 9.43057 1.16461 9.08377L1.2459 8.98441L8.56679 1.25947C8.89466 0.91351 9.42624 0.91351 9.7541 1.25947Z" stroke-width="0.5"/> </svg>',
        '<svg width="11" height="19" viewBox="0 0 11 19" fill="#200E32" stroke="#200E32" xmlns="http://www.w3.org/2000/svg"> <path d="M1.2459 1.25947C0.94784 1.57398 0.920743 2.06614 1.16461 2.41294L1.2459 2.5123L7.97342 9.61082L1.2459 16.7093C0.94784 17.0239 0.920743 17.516 1.16461 17.8628L1.2459 17.9622C1.54396 18.2767 2.01037 18.3053 2.33904 18.0479L2.43321 17.9622L9.7541 10.2372C10.0522 9.92273 10.0793 9.43057 9.83539 9.08377L9.7541 8.98441L2.43321 1.25947C2.10534 0.91351 1.57376 0.91351 1.2459 1.25947Z" stroke-width="0.5"/> </svg>'
      ],
    }).on('changed.owl.carousel', syncPosition);

  }

  if (sync2.length > 0) {
    sync2.on('initialized.owl.carousel', function () {
      sync2.find(".owl-item").eq(0).addClass("current");
    })
      .owlCarousel({
        items: slidesPerPage,
        dots: false,
        nav: true,
        smartSpeed: 200,
        slideSpeed: 500,
        autoHeight: true,
        slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
        responsiveRefreshRate: 100,
        navText: [
          '<i class="fa fa-angle-left" aria-hidden="true"></i>',
          '<i class="fa fa-angle-right" aria-hidden="true"></i>'
        ],
      }).on('changed.owl.carousel', syncPosition2);
    sync2.on("click", ".owl-item", function (e) {
      e.preventDefault();
      var number = $(this).index();
      sync1.data('owl.carousel').to(number, 300, true);
    });

  }

  function syncPosition(el) {
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - (el.item.count / 2) - .5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }

    //end block

    sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
    var onscreen = sync2.find('.owl-item.active').length - 1;
    var start = sync2.find('.owl-item.active').first().index();
    var end = sync2.find('.owl-item.active').last().index();

    if (current > end) {
      sync2.data('owl.carousel').to(current, 100, true);
    }
    if (current < start) {
      sync2.data('owl.carousel').to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      sync1.data('owl.carousel').to(number, 100, true);
    }
  }
  var videoSlider = $('.owl-carousel');


  videoSlider.on('translate.owl.carousel', function (e) {
    $('.owl-item .item video').each(function () {
      // pause playing video - after sliding
      $(this).get(0).pause();
    });
  });

  videoSlider.on('translated.owl.carousel', function (e) {
    // check: does the slide have a video?
    if ($('.owl-item.active').find('video').length !== 0) {
      // play video in active slide
      $('.owl-item.active .item video').get(0).play();
    }
  });

  // $('<span>Blade Refill Club</span>').insertAfter('.product-baldiepro-head-shaver-kit .smart-drawer__item-data'); 
  var cartdiscountamount = $('.cart_discount_amount').html();
  var fomattedamount = (cartdiscountamount / 100).toFixed(2);
  $('.cart_discount_amount').html('$' + fomattedamount);
});


$(window).on('load', function () {

  $(".recom_product_slider .product-grid-item ").each(function () {

  });

  //$(document).on("click",".js-drawer-open-cart",function() {
  $('.cart_link').click(function () {
    $('#rebuy-cart').toggleClass('is-visible');
  });
  // Variant option click
  $('.variant__button-label').click(function () {
    var currentopt = $(this).text();
    setTimeout(function () {
      $(".subscribe").find(".right").html($(".rc_widget__price--subsave").html());
      $(".onetime").find(".right").html($(".rc_widget__price--onetime").html());
    }, 500);
    $("#productSelect--product-template > option").each(function () {
      //console.log(this.text + ' ' + this.value);
      if ($(this).data("title") == currentopt) {
        $("#variant_sku").val($(this).data("sku"));
      }
    });

  });




  $('#NavDrawer .close-button').click(function () {
    $('body').removeClass('js-drawer-open-left');
  });
  $('.menu__toggle').click(function () {
    $('body').toggleClass('js-drawer-open-left');
  });


  $('.best-seller-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.recom_product_slider').css("display", "block");
  $('.recom_product_slider').not('.slick-initialized').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1


        }
      }
    ]
  });

  $('.template-cart .stamped-badge-caption').each(function () {
    $(this).html("");
    $(this).html(" " + $(this).attr("data-rating") + "/5.0");
  });
  $(".best-selling-products").show();
});
function stopVideos() {
  $('.cust_play').attr('src', '');
  $('.cust_vid_overlay').show();
}
$(document).ready(function () {
  $(document).on('click', '.smart-drawer__close', function () {
    if ($("#rebuy-cart").hasClass("is-visible")) {
      $("#rebuy-cart").removeClass("is-visible");
    }
  });

  $('#subscribe').click(function () {
    var a1 = $('#subscribe').is(':checked');
    if (a1 == true) {
      console.log($("#subscribe").val());
    }

  });

  $('#onetime').click(function () {
    var b1 = $('#onetime').is(':checked');
    if (b1 == true) {
      console.log($("#onetime").val());
    }

  });
  if ($('#home_cust_review').length) {
    owl = $('#home_cust_review').owlCarousel({
      loop: true,
      responsiveClass: true,
      center: false,
      onDragged: stopVideos,
      onDrag: stopVideos,
      nav: true,
      dots: false,
      touchDrag: true,
      mouseDrag: true,
      responsive: {
        0: {
          items: 1,
          navigation: false
        },
        480: {
          items: 2,
          nav: true
        },
        767: {
          items: 3,
          nav: true
        }
      }
    });

    owl.on('changed.owl.carousel', function (e) {
      stopVideos();
    });

  }
  setTimeout(function () {
    $("#rad_option1").click();
    $('.loader-bg').hide();
  }, 1500);


  if ($('body').hasClass('template-product')) {
    $('#watch-video').on('click', function (ev) {
      var src = $("#play-video").data('src') + '?autoplay=1&rel=0&controls=0';
      //var ret = src.split("?autoplay=1&rel=0&controls=0");
      $("#play-video").attr('src', src);
      $('.product-detail_video .vide-overlay').hide();
    });
  }

  /* Cart Drawer Start */
  $('.cart_drawer, .smart-drawer__close .fal').on('click', function() {
    console.log("Open Click!! fire");
    $("#rebuy-cart").toggleClass("is-visible");
  });

  $(".wls-header__cart, .cart_link").on("click", function() {
      console.log('cart clicked 2');
      $('.smart-drawer__wrapper').addClass("is-visible");
      $('.cart_link').addClass("active");
      $('.smart-drawer__wrapper').css('visibility', 'visible');
  });
  $(document).ready(function() {
    $(".wls-header__cart, .cart_link").on("click", function() {
        console.log('cart clicked 3');
        $('.smart-drawer__wrapper').addClass("is-visible");
    });
});

  $(document).on("click", ".smart-drawer__close", function() {
      console.log("Close Click!! fire");
      $('#rebuy-cart').removeClass('is-visible');
      $('.cart_link').removeClass("active");
      $('.smart-drawer__wrapper').css('visibility', 'hidden');
  });
  /* Cart Drawer End */


  /*homepage cutomer review start*/
  $('#home_cust_review .video-block').on('click', function (ev) {
    var video_src = $(this).find('.cust_vid_overlay').data('src') + '?autoplay=1&rel=0&controls=1';
    //console.log(video_src);
    $('.cust_play').attr('src', '');
    $('.cust_vid_overlay').show();

    $(this).find('.cust_play').attr('src', video_src);
    $(this).find('.cust_vid_overlay').hide();
  });


  /*homepage cutomer review end*/

  if ($('body').hasClass('template-product')) {
    $('.primary-btn, .play-icon img').on('click', function (ev) {
      var src = $(".play-video").attr('src') + '?autoplay=1&rel=0&controls=0';
      var ret = src.split("?autoplay=1&rel=0&controls=0");
      $(".play-video").attr('src', ret[0] + '?autoplay=1&rel=0&controls=0');
      $(this).parents(".vide-overlay").hide();
    });
  }
  $(".play-icon-landing").click(function () {
    $(".video-play-btn").click();
  });
  $('.play-icon').on('click', function (ev) {
    console.log('here1');
    var src = $("#play-video").data('usesrc') + '?autoplay=1&rel=0&controls=0';
    //var ret = src.split("?autoplay=1&rel=0&controls=0");
    $("#play-video").attr('src', src);
    $("#play-video").css('z-index', '1');
    $('body#limited-1 .video-overlay').hide();

  });


  $('.play-icon-button').on('click', function (ev) {
    console.log('here2');
    var src = $(this).parent().next().attr('data-src') + '?autoplay=1&rel=0&controls=1&mute=1&playsinline=1';
    var ret = src.split("?autoplay=1&rel=0&controls=0&mute=1&playsinline=1");
    $(this).parent().next().attr('src', ret[0] + '?autoplay=1&rel=0&controls=1&mute=1&playsinline=1');
    $(this).closest('.vide-overlay').hide();
    if (window.matchMedia("(max-width: 768px)").matches) {
      var e = document.getElementById("play-video");
      if (e.requestFullscreen) {
        e.requestFullscreen();
      } else if (e.webkitRequestFullscreen) {
        e.webkitRequestFullscreen();
      } else if (e.mozRequestFullScreen) {
        e.mozRequestFullScreen();
      } else if (e.msRequestFullscreen) {
        e.msRequestFullscreen();
      }
    }
  });

  /*Home page owl slider*/
  if ($('.customer-review_slider').length) {
    $('.customer-review_slider').owlCarousel({
      loop: true,
      margin: 0,
      items: 1,
      nav: false,
      dots: true,
      touchDrag: false,
      mouseDrag: false
    });
  }

  if ($('.featured-slider').length) {
    $('.featured-slider').owlCarousel({
      loop: false,
      margin: 0,
      items: 4,
      nav: false,
      dots: false,
      responsive: {
        0: {
          items: 2
        },
        768: {
          items: 3
        },
        992: {
          items: 4
        }
      }
    });
  }
  $('.has-children').children('a').on('click', function (event) {
    //prevent default clicking on direct children of .has-children 
    event.preventDefault();
    var selected = $(this);
    selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
  });
  //submenu items - go back link
  $('.go-back').on('click', function () {
    var selected = $(this),
      visibleNav = $(this).parent('ul').parent('.has-children').parent('ul');
    selected.parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('move-out');
  });

  $(".tab-content").hide();
  $("ul.tabs li:first").addClass("active").show();
  $(".tab-content:first").show();
  $("ul.tabs li").click(function () {
    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  //User Manual page JS
  $(".product-features .sidebar-menu li").click(function () {
    $(this).addClass('active').siblings().removeClass('active');
  });

  //variation product
  $(".product-type li label").click(function () {
    $(this).next().addClass('active');
    $(this).parent().siblings().find('.varation-wrap').removeClass('active');
    $(".js-qty__input").attr('name', 'quantityolp');
    $(this).siblings().find(".js-qty__input").attr('name', 'quantity');
    setTimeout(function () {
      //$(".varation-wrap.active").prev().find(".main-price").html($(".recharge-inner-most-price").html());
    }, 800);
  });

  setTimeout(function () {
    $("div#rc_login").hide();
  }, 1500);
  setTimeout(function () {
    $("div#rc_login").hide();
  }, 2000);


  //FAQ Search Page
  $('.searchTerm').keyup(function () {

    var searchTerm = $('.searchTerm').val();

    var is_found = 0;

    $('#no_result').hide();

    if ($.trim(searchTerm) != '') {

      $('.faq-page-section .card').each(function () {

        var card = $(this);

        var heading = card.find('.btn-link').html();
        var content = card.find('.card-body').html();

        var searchTerm_uppercase = searchTerm.charAt(0).toUpperCase() + searchTerm.slice(1);

        if (heading.indexOf(searchTerm) !== -1 || content.indexOf(searchTerm) !== -1 || heading.indexOf(searchTerm_uppercase) !== -1 || content.indexOf(searchTerm_uppercase) !== -1) {

          card.show();
          is_found = 1;
        } else {
          card.hide();
        }

      });

      //not found
      if (is_found == 0) {

        $('#no_result').show();
      }

    } else {
      $('.card').show();
    }
  });

  //add active class to selected menu(Header & Footer)
  var url = window.location.href;
  var slug = '/' + url.split("/").slice(-1).join("/");

  $('a').each(function (link) {
    if (link.href == document.location.href) {
      Element.addClassName(link, 'active');
    };
  });

  $('.main-navigation li a').click(function () {

    var element = $(this);

    $('.main-navigation li a').each(function () {
      $(this).removeClass('active');
    });

    element.addClass('active');
  });

  $('.main-navigation-mobile li a').click(function () {

    var element = $(this);

    $('.main-navigation li a').each(function () {
      $(this).removeClass('active');
    });

    element.addClass('active');
  });

  $('.main-navigation li a, .footer-menu li a').each(function () {

    if (slug != '/') {
      var $this = $(this);
      $this.removeClass('active');
      // if the current path is like this link, make it active
      if ($this.attr('href').indexOf(slug) !== -1) {
        $this.addClass('active');
      }
    }

    //for "account"
    if (slug == '/login?return_url=%2Faccount') {

      if ($this.attr('href').indexOf('/account') !== -1) {
        $this.addClass('active');
      }
    }

    //for "product page"
    var og_type = $('meta[property="og:type"]').attr('content');
    if (og_type == 'product') {

      if ($this.attr('class') == 'nav-item shop-item') {
        $this.addClass('active');
      }
    }

  });

  //homepage when click on add to cart
  $('#home_ AddToCart').click(function () {

    if ($("#onetime_varient_id").val() == "42918220595370") {
      var ID = 41049861914794;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: ID
        },
        dataType: 'json',
        success: function (data) {
          var homeprod_query_url = $('#homeprod_query_url').val();
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: homeprod_query_url,
            dataType: 'json',
            success: function () {
              //ajaxCart.load();
              //window.location.href = '/cart/';
            }
          });
        }
      });
    }
    else {
      var homeprod_query_url = $('#homeprod_query_url').val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: homeprod_query_url,
        dataType: 'json',
        success: function () {

          //ajaxCart.load();
          //window.location.href = '/cart/';
        }
      });
    }
  });

  //sharing js
  $('.share .share-info').click(function () {
    $(this).next('.sharing-options').animate({
      width: "toggle"
    });
  });


  //product detail page
  if ($('body').hasClass('template-product') || $('body').hasClass('template-index') || $('body').hasClass('template-page')) {

    //scroll to div
    if ($('body').hasClass('template-product')) {
      $('.stamped-product-reviews-badge').click(function () {
        $('html, body').animate({
          scrollTop: $(".product-review").offset().top - 200
        }, 2000);
      });

      var url = window.location.href;
      var index = url.indexOf("#");
      if (index !== -1) {
        var hash = url.substring(index + 1);

        if (hash == 'customer_reviews') {

          setTimeout(function () {

            $('html, body').animate({
              scrollTop: $(".customer_reviews").offset().top + 400
            }, 2000);

          }, 500);
        }
      }

      var checkExistSub_pr = setInterval(function () {
        if ($('.rc-selling-plans__dropdown').length) {
          var sell_price = $('.product-type .subscribe .right').html();
          $(".sell_price").html(sell_price);
          clearInterval(checkExistSub_pr);
        }
      }, 10);// check every 100ms
    }






    //if homepage then make the query string of the selected product for add to cart
    if ($('body').hasClass('template-index') || $('body').hasClass('template-page')) {

      var onetime_frequency = $('#onetime_frequency').val();
      var onetime_varient_id = $('#onetime_varient_id').val();
      var onetime_title = $('#onetime_title').val();

      //default call
      makeHomePageQuery('onetime', onetime_frequency, onetime_varient_id, onetime_title);

      $('ul.product-type li').click(function () {
        var data_option = $(this).data("option");
        console.log(data_option);
        if (data_option == 'onetime') {

          $("#rad_option2").prop("checked", true);
          $("#rad_option1").prop("checked", false);

          var home_sellprice = $('.option2 .right').html();
          $('.sell_price').html(home_sellprice);
          $('.home_compare_price').show();

          makeHomePageQuery('onetime', onetime_frequency, onetime_varient_id, onetime_title);
          $('#warrantytext').html('1 Year Warranty');
        } else { //subsave

          $("#rad_option1").prop("checked", true);
          $("#rad_option2").prop("checked", false);

          var home_sellprice = $('#home_sellprice').html();
          $('.sell_price').html(home_sellprice);

          var subsave_val = $('.cusSelect').val();

          $('.cusSelect').on('change', function () {
            subsave_val = $(this).val();
          });

          var subsave_arr = subsave_val.split('*');

          $('.home_compare_price').show();

          makeHomePageQuery('subsave', subsave_arr[2], subsave_arr[1], subsave_arr[0], subsave_arr[3]);
          $('#warrantytext').html('Lifetime Warranty');
        }
      });


      $('.cusSelect').on('change', function () {
        subsave_val = $(this).val();
        var subsave_arr = subsave_val.split('*');
        makeHomePageQuery('subsave', subsave_arr[2], subsave_arr[1], subsave_arr[0], subsave_arr[3]);
      });

      //on reviews click redirect to product page
      $('.scroll-review').click(function () {


        $('html, body').animate({
          scrollTop: $('#header-reviews').offset().top - 100
        }, 1000);

      });
    }
  }

});

function refreshCart() {

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    data: '',
    dataType: 'json',
    success: function (response) {

      var total_price = '$' + (response.total_price / 100).toFixed(2);
      var total_items = response.item_count;
      var items = response.items;

      var line_items_prices = new Array();
      var line_items_quantity = new Array();

      for (i = 0; i < items.length; i++) {
        line_items_prices.push('$' + (items[i].line_price / 100).toFixed(2));
        line_items_quantity.push(items[i].quantity);
      }

      //$('#CartDrawer').find('.drawer__title').html(total_items+' item in your cart');
      $('#CartDrawer').find('.price--amount').html('<h4 class="price">' + total_price + '</h4>');

      $("#CartDrawer .ajaxcart__product").each(function (index) {
        $('.main-navigation').find('.cart__count').text(total_items);
        $(this).find('.ajaxcart__product__price').val(line_items_prices[index]);
        $(this).find('.js-qty__input').val(line_items_quantity[index]);
      });
    }
  });
}

$(window).scroll(function () {
  var scrollDistance = $(window).scrollTop();
  // Assign active class to nav links while scolling
  $('.sidebar-menu li').each(function (i) {
    if ($(this).position().top <= scrollDistance) {
      $('.navigation a.active').removeClass('active');
      $('.navigation a').eq(i).addClass('active');
    }
  });
}).scroll();


function makeHomePageQuery(type, frequency, varient_id, title, days = "") {

  var qty = $('.home_qty__input').val();

  if (type == 'onetime') {
    var query_string = 'selling_plan_244166=' + type + '&form_type=product&utf8=%E2%9C%93&frequency=' + frequency + '&Product+Type=' + title + '&form_type=product&utf8=%E2%9C%93&id=' + varient_id + '&quantityolp=' + qty + '&quantity=' + qty;
  } else {
    var ig_experiment_id = "c91dad44-63af-4a85-849e-d75da98d8cf4";
    var test_group_id = window.igData?.user.getTestGroup(ig_experiment_id);


    var new_selling_plan_id = new_recharge_variant_id = '';
    var recharge_variant_map = {
      "a24a750d-de1d-4250-8ee8-b3e609822fb8": {
        "30": 814448810,
        "45": 1030291626,
        "60": 626327722
      },
      "566527da-e9ea-4dd2-b044-b416d9ff8d0f": {
        "30": 1036124330,
        "45": 1036157098,
        "60": 1036189866
      },
      "f51a8b04-f440-4adf-bc92-02de4db1bc2e": {
        "30": 1036091562,
        "45": 1036222634,
        "60": 1036255402
      }
    };
    var selling_plan_id_map = {
      "a24a750d-de1d-4250-8ee8-b3e609822fb8": 6893061669034,
      "566527da-e9ea-4dd2-b044-b416d9ff8d0f": 7574834479274,
      "f51a8b04-f440-4adf-bc92-02de4db1bc2e": 7574834544810,
    };
    if (test_group_id && test_group_id != 'null') {
      var new_shopify_variant_id = igData.price.getAltVariantId(varient_id);
      new_selling_plan_id = selling_plan_id_map[test_group_id.id]
      new_recharge_variant_id = recharge_variant_map[test_group_id.id][days]
      //console.log("plan_id " + new_selling_plan_id + "recharge_var_id " + new_recharge_variant_id);  
    }
    if (new_selling_plan_id) {
      sellingplanid = new_selling_plan_id;
    } else {
      sellingplanid = frequency;
    }

    if (new_recharge_variant_id) {
      frequency = new_recharge_variant_id;
    }

    if (new_shopify_variant_id) {
      varient_id = new_shopify_variant_id;
    }

    //var query_string = 'selling_plan_244166='+type+'&selling_plan='+frequency+'&form_type=product&utf8=%E2%9C%93&Product+Type='+title+'&frequency='+frequency+'&form_type=product&utf8=%E2%9C%93&id='+varient_id+'&quantity='+qty+'&quantityolp='+qty+'&properties%5Bsubscription_frequency%5D=Delivery+of+blade+refill+every+'+days+'+Days&purchase_type=subscribe';    
    var query_string = 'selling_plan_244166=' + type + '&selling_plan=' + frequency + '&form_type=product&utf8=%E2%9C%93&Product+Type=' + title + '&frequency=' + frequency + '&form_type=product&utf8=%E2%9C%93&id=' + varient_id + '&purchase_type=subscribe&quantity=' + qty + '&quantityolp=' + qty;
  }

  $('#homeprod_query_url').val(query_string);
}

function youtube_parser(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match && match[7].length == 11) ? match[7] : false;
}
/*Product Detail How it works feat*/
$(document).ready(function () {

  $('.how-works-feat .listing ').slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $('.limited1 .as-seen-logos ul').slick({
    arrows: false,
    dots: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    pauseOnHover: false,
    cssEase: 'linear',
    touchMove: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  $('.how-works-feat .listing li').each(function () {
    var play = $(this).find('.wrap');
    var iframe = $(this).find('.work-video');
    $(play).on('click', function () {
      $(play).find(".play").hide();
      var src2 = $(iframe).data('usesrc') + '?autoplay=1&rel=0&controls=1';
      $(iframe).attr('src', src2);
      $(iframe).css("zIndex", "4");
    });
  });

  $(document).on('click', 'a.ScrollToID[href^="#"]', function (e) {
    // target element id
    var id = $(this).attr('href');

    // target element
    var $id = $(id);
    if ($id.length === 0) {
      return;
    }

    // prevent standard hash navigation (avoid blinking in IE)
    e.preventDefault();

    // top position relative to the document
    var pos = $id.offset().top - 130;

    // animated top scrolling
    $('body, html').animate({ scrollTop: pos });
  });

});

// if (window.innerWidth <= 767) {
// 	$(document).ready(function () {
// 		var slider = $('.feedback-slider-mob .feedback-slider').slick({
// 			slidesToShow: 1,
// 			slidesToScroll: 1,
// 			dots: true,
// 			prevArrow: '.wls-how-it-works__prev',
// 			nextArrow: '.wls-how-it-works__next',
// 		});

// 		$('.wls-how-it-works__prev, .wls-how-it-works__next').on('click', function () {
// 			var currentSlide = slider.slick('slickCurrentSlide');
// 			var currentVideo = $('.wls-how-it-works__step').eq(currentSlide).find('.wls-how-it-works__step-video video')[0];

// 			if (currentVideo && !currentVideo.paused) {
// 				currentVideo.pause();
// 			}
// 		});
// 	});
// }
// END HOW IT WORKS

// feedback slider
$('.feedback-section .feedback-slider').slick({
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  draggable: true,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 3,
         arrow: true,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 768,
      settings: {
         dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
         arrow: true,
         dots: true,
        // centerMode: true,
        // centerPadding: '60px',
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1, 
        // centerMode: true,
        // centerPadding: '40px',
        dots: true,
        arrow: true,
      }
    }
   
  ]
});

// Initialize Swiper for review and meet creators sections
// const swiper = new Swiper('.feedback-section .feedback-slider', {
//   slidesPerView: 4, // Default setting for screens 990px and above
//   spaceBetween: 20,
//   centeredSlides: false,
//   loop: false,
//   navigation: {
//     nextEl: ".swiper-button-next", 
//     prevEl: ".swiper-button-prev",
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   }, 
//   breakpoints: {
//     989: {
//       slidesPerView: 3,
//       spaceBetween: 20, // Adjust spacing if needed
//     },
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 16, // Adjust spacing if needed
//     },
//     0: { // This covers all sizes below 767px
//       slidesPerView: 1.4,
//       spaceBetween: 12, // Adjust spacing if needed
//     },
//   },
// });

$('.whats-include-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
function toggleAccordion(element) {
    let accordions = document.querySelectorAll(".accordion");
    let isMobile = window.innerWidth <= 768; // Check if it's mobile view

    // Loop through all accordion items
    accordions.forEach(acc => {
        if (acc !== element) {
            acc.classList.remove("active");
            let popup = acc.querySelector(".popup-wrapper");
            if (popup) {
                popup.classList.remove("open"); // Close other popups in mobile
                document.body.style.overflow = ""; // Restore scrolling when closing popup
            }
        }
    });

    // Toggle the 'active' class on the clicked accordion
    element.classList.toggle("active");

    // Handle mobile popup
    if (isMobile) {
        let popup = element.querySelector(".popup-wrapper");
        if (popup) {
            popup.classList.toggle("open");
            // Prevent scrolling when popup is open
            document.body.style.overflow = popup.classList.contains("open") ? "hidden" : "";
        }
    }
}

// Close popup when clicking outside or on close button
document.addEventListener("click", function (event) {
    let popups = document.querySelectorAll(".popup-wrapper.open");
    popups.forEach(popup => {
        if (!popup.closest(".accordion").contains(event.target) || event.target.closest(".icon-close")) {
            popup.classList.remove("open");
            popup.closest(".accordion").classList.remove("active");
            document.body.style.overflow = ""; // Restore scrolling when closing popup
        }
    });
});
// Benefit section slider
$('.benefit-section .benefit-slider').slick({
      slidesToShow: 4, // Default number of slides to show for larger screens
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0, // No delay between slides
      speed: 3000, // Smooth continuous scrolling
      arrows: false, // Disable navigation arrows
      cssEase: 'linear',
      variableWidth: true,
      infinite: true, // Loop infinitely
      pauseOnHover: false, // Keep sliding when hovering
  });
// customer feedback slider
$('.customer-feedback .customer-slider').slick({
  arrows: true,
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  draggable: true,
  swipe: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        infinite: true,
        slidesToShow: 2,
         arrow: true,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 768,
      settings: {
         dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
         arrow: true,
         dots: false,
        
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1, 
        dots: true,
        arrow: true,
      }
    }
   
  ]
});

// popup js for welcome1 page 
document.addEventListener("DOMContentLoaded", function () {
  const badges = document.querySelectorAll(".whats-included-badge");
  const popups = document.querySelectorAll("kit-popup");
  const overlay = document.querySelector(".product-kit-popup-overlay");

  // Open popup
  badges.forEach((badge) => {
    badge.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);

      // Close other popups if open
      popups.forEach((p) => p.classList.remove("active"));
      overlay.classList.add("active");

      if (popup) {
        popup.classList.add("active");
      }
    });
  });

  // Close on overlay click
  overlay.addEventListener("click", function () {
    popups.forEach((popup) => popup.classList.remove("active"));
    this.classList.remove("active");
  });

  // Optional: Add close buttons to popups if desired
  const closeButtons = document.querySelectorAll("kit-popup .close-btn");
  closeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      btn.closest("kit-popup").classList.remove("active");
      overlay.classList.remove("active");
    });
  });
});


//loader Modified
// $(document).ready(function () {
//   let loaderFaded = false;

//   // Function to fade out loader once
//   function fadeOutLoader() {
//       if (!loaderFaded) {
//           $(".loader-bg").fadeOut();
//           loaderFaded = true;
//       }
//   }

//   // Start checking for the slick-initialized class
//   const checkInterval = setInterval(function () {
//       if ($(".wls-shop__gallery-main.slick-initialized").length > 0) {
//           fadeOutLoader();
//           clearInterval(checkInterval);
//       }
//   },10);

//   // If window finishes loading and the class hasn't appeared, fade out anyway
//   $(window).on("load", function () {
//         $(".loader-bg").fadeOut();
//   });
// });


// function initSlickIfMobile() {
function initSlickIfMobile() {
  const $slider = $('.category-browse-section .category-grid');

  if (window.innerWidth <= 768) {
    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        arrows: true,
        dots: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchMove: false,
        draggable: false,
      });
    }
  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

// Initialize on page load
$(document).ready(initSlickIfMobile);

// Re-check on window resize
$(window).on('resize', initSlickIfMobile);

// collection slider
  $('.product-grid .product-card-slider').slick({
    speed: 300,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
  ]
});
